import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IGeneralSettingsState } from './general-settings.state';

export const selectGeneralSettingsState =
  createFeatureSelector<IGeneralSettingsState>('generalSettings');

export const selectGeneralSettingsData = createSelector(
  selectGeneralSettingsState,
  (state) => state
);
